import React, { forwardRef, useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { CoreContext } from './context/index.js';
import MiniShoppingCart from './components/MiniShoppingCart/index.js';
import { useRouter } from 'next/router';
import 'lodash/get';
import './utils/price.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import './utils/logToSlack.js';
import { getCookie } from './utils/cookies.js';
import './utils/currency.js';
import { b as COOKIE_CURRENCY_NAME } from './cookies-l-jEMp6P.js';
import { C as CurrencyCode, b as CURRENCY_SYMBOLS } from './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';
import './product-_pRduMz7.js';
import './helpers-qU2Vf3ni.js';
import 'lodash';
import Link from './components/Link/index.js';
import { S as ShoppingCartDrawerButton } from './CartDrawerButton-2eYmUV78.js';
import { M as MobileMenu } from './MobileMenu-qB5b53m6.js';
import { ActionType, UtilityIcons } from './types/index.js';
import './checkout-Ee1eEXQH.js';
import './menu-0TyOg98i.js';
import './modal-6vnX5SO3.js';
import { selectCurrentCurrencyCode } from './storeSelectors/currencies.js';

const ActionBar = forwardRef(({ isCheckout, iconOrder = [
    UtilityIcons.ShoppingCart,
    UtilityIcons.Language,
    UtilityIcons.Search,
    UtilityIcons.Currency,
    UtilityIcons.MobileMenu,
    UtilityIcons.Account,
], onAction, }, ref) => {
    var _a, _b;
    const { data: { currency: currencyCode, siteConfig: { header: { mobileMenuIconOrder = [ActionType.Language, ActionType.Currency] } = {}, account: { accountGlobalEnable = false, disableAccountDrawer = false } = {}, cart: { useCartDrawer = false } = {}, }, }, } = useContext(CoreContext);
    const { locale } = useRouter();
    const { useSelector } = useContext(CoreContext);
    const currencyCookie = (_a = getCookie(COOKIE_CURRENCY_NAME)) !== null && _a !== void 0 ? _a : '';
    const selectorCurrency = (_b = useSelector(selectCurrentCurrencyCode)) !== null && _b !== void 0 ? _b : currencyCode;
    const icon = (currencyCookie || selectorCurrency || CurrencyCode.EUR).toLowerCase();
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const setActionType = (action) => {
        onAction(action);
    };
    const onKeyUp = (e, action) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.key === ' ' || e.key === 'Enter') {
            setActionType(action);
        }
    };
    const getCurrencyDisplay = (passedCurrencyCode) => {
        if (passedCurrencyCode === CurrencyCode.AED || passedCurrencyCode === CurrencyCode.CHF) {
            return passedCurrencyCode;
        }
        return `${passedCurrencyCode} (${CURRENCY_SYMBOLS[passedCurrencyCode]})`;
    };
    const currencyDisplay = currencyCookie
        ? getCurrencyDisplay(currencyCookie)
        : getCurrencyDisplay(selectorCurrency);
    const isLogged = useSelector((state) => state.user.authenticated);
    const accountHref = isLogged ? `/${locale}/account/settings` : `/${locale}/user/login`;
    const actionElements = {
        [UtilityIcons.ShoppingCart]: (React.createElement("li", { className: "cart-item", key: "cart", "data-event-name": "menu_interact_other", "data-menu-label": "$cart" },
            !useCartDrawer && React.createElement(MiniShoppingCart, null),
            useCartDrawer && (React.createElement(ShoppingCartDrawerButton, { onKeyUp: onKeyUp, setActionType: setActionType })))),
        [UtilityIcons.Language]: !isCheckout && (React.createElement("li", { key: "language", "data-event-name": "menu_interact_other", "data-menu-label": "$language", className: classnames('language-item', mobileMenuIconOrder.includes(ActionType.Language) && 'mobile-hide') },
            React.createElement("button", { "data-testid": "language-button", id: "language-button", className: classnames('ab-icon', 'icon-location', 'button-reset', locale), type: "button", "aria-label": tHeading('languageSelection'), onKeyPress: event => onKeyUp(event, ActionType.Language), onClick: () => setActionType(ActionType.Language) }))),
        [UtilityIcons.Search]: !isCheckout && (React.createElement("li", { key: "search", "data-event-name": "menu_interact_other", "data-menu-label": "$search", className: classnames('search-item', mobileMenuIconOrder.includes(ActionType.Search) && 'mobile-hide') },
            React.createElement("button", { "data-testid": "search-button", id: "search-button", className: "ab-icon icon-search button-reset", "aria-label": tLabel('productSearch'), type: "button", onKeyPress: event => onKeyUp(event, ActionType.Search), onClick: () => setActionType(ActionType.Search) }))),
        [UtilityIcons.Currency]: !isCheckout && (React.createElement("li", { key: "currency", "data-event-name": "menu_interact_other", "data-menu-label": "$currency", className: classnames('currency-item', mobileMenuIconOrder.includes(ActionType.Currency) && 'mobile-hide') },
            React.createElement("button", { "data-testid": "currency-button", id: "currency-button", className: classnames('ab-icon', `icon-${icon}`, 'button-reset'), type: "button", "aria-label": tLabel('currencySelection'), onKeyPress: event => onKeyUp(event, ActionType.Currency), onClick: () => setActionType(ActionType.Currency) },
                React.createElement("span", null, currencyDisplay)))),
        [UtilityIcons.Account]: !isCheckout && accountGlobalEnable && (React.createElement("li", { key: "account", "data-event-name": "menu_interact_other", "data-menu-label": "$account", className: classnames('account-item', mobileMenuIconOrder.includes(ActionType.Account) && 'mobile-hide') }, disableAccountDrawer ? (React.createElement(Link, { href: accountHref, className: "account-link" },
            React.createElement("button", { id: "account-button", className: "ab-icon icon-user button-reset", "aria-label": tLabel('myAccount'), type: "button" }))) : (React.createElement("button", { id: "account-button", className: "ab-icon icon-user button-reset", "aria-label": tLabel('myAccount'), type: "button", onKeyPress: event => onKeyUp(event, ActionType.Account), onClick: () => setActionType(ActionType.Account) })))),
        [UtilityIcons.MobileMenu]: !isCheckout && (React.createElement("li", { className: "mobile-item", key: "mobile-menu" },
            React.createElement(MobileMenu, { onAction: onAction }))),
    };
    return (React.createElement("ul", { ref: ref, className: "utilities" }, iconOrder.map(action => actionElements[action])));
});
ActionBar.displayName = 'ActionBar';

export { ActionBar as A };
//# sourceMappingURL=ActionBar-_-_7UhKr.js.map
